import React, { ReactNode } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-native'

import useController from '@common/hooks/useController'
import { ROUTES } from '@common/modules/router/constants/common'
import { savePendingDeepLink } from '@common/modules/router/helpers/pendingDeepLink'

const KeystoreUnlockedRoute = ({ children }: { children?: ReactNode }) => {
  const keystoreState = useController('KeystoreController').state
  const location = useLocation()
  const shouldNavigateToUnlock = keystoreState.isReadyToStoreKeys && !keystoreState.isUnlocked

  // The redirect below rewrites the URL, so anything the user was pointed at —
  // in particular a deep link carrying `?dappId=…&dappUrl=…` — is lost unless we
  // stash it first. Restored after unlock by usePendingDeepLinkRestore.
  if (shouldNavigateToUnlock) savePendingDeepLink(location.pathname, location.search)

  return shouldNavigateToUnlock ? <Navigate to={ROUTES.keyStoreUnlock} /> : children || <Outlet />
}

export default KeystoreUnlockedRoute
